import axios from "axios";
import { handleGraphQLError, APiUrl } from "../helper";

export const getAboutUs = async () => {
    try {
        const response = await axios.post(
            APiUrl,
            {
                query: `query AboutUS { page(id: 7, idType: DATABASE_ID) { aboutUs { title subtitle ceoSectionContent staticimages { title description file { node { sourceUrl } } } ceoSectionImages { ceo { title description file { node { sourceUrl } } } robot { title description file { node { sourceUrl } } } signature { description title file { node { sourceUrl } } } } ourMission { content subTitle title rightImage { node { sourceUrl } } bottomImage { node { sourceUrl } } } ourVision { description fieldGroupName subtitle title } bottomRobot { content image { node { sourceUrl } } } meetOurTeam { card1 { name role image { node { sourceUrl } } } card2 { name role image { node { sourceUrl } } } card3 { name role image { node { sourceUrl } } } title description card4 { name role image { node { sourceUrl } } } } ourCoreValues { title image { node { sourceUrl } } card3 { description title image { node { sourceUrl } } } card2 { description title image { node { sourceUrl } } } card1 { description title image { node { sourceUrl } } } } } slug title } }`,
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        const json = response.data;

        if (json.errors) {
            handleGraphQLError(json.errors[0].message);
        } else {
            return json?.data?.page?.aboutUs ?? [];
        }
    } catch (err) {
        handleGraphQLError(err.message);
    }
};



